import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { useUser } from '../../../contexts/UserContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { loginRequest } from '../../../authConfig';

const InvoiceRedirect = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { user, loading: userLoading } = useUser();
  const [redirecting, setRedirecting] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const activeAccount = instance.getActiveAccount();
        
        if (!activeAccount || !accounts.length) {
          sessionStorage.setItem('redirectAfterLogin', `/i-r/${invoiceId}`);
          await instance.loginRedirect(loginRequest);
          return;
        }

        await instance.initialize();
        
        try {
          await instance.acquireTokenSilent({
            ...loginRequest,
            account: activeAccount,
          });
        } catch (silentError) {
          if (silentError instanceof InteractionRequiredAuthError) {
            sessionStorage.setItem('redirectAfterLogin', `/i-r/${invoiceId}`);
            await instance.acquireTokenRedirect({
              ...loginRequest,
              account: activeAccount,
            });
            return;
          }
          throw silentError;
        }

        if (userLoading) {
          return;
        }

        navigate(`/i-r/${invoiceId}`, { replace: true });
        
      } catch (err) {
        console.error('Redirect error:', err);
        setError('אירעה שגיאה בתהליך ההפניה');
      } finally {
        setRedirecting(false);
      }
    };

    if (invoiceId) {
      handleRedirect();
    } else {
      setError('מזהה החשבונית חסר');
      setRedirecting(false);
    }
  }, [invoiceId, navigate, instance, accounts, user, userLoading]);

  useEffect(() => {
    const checkPostLoginRedirect = () => {
      const redirectPath = sessionStorage.getItem('redirectAfterLogin');
      if (redirectPath && !userLoading && user?.accessRights && accounts.length > 0) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectPath, { replace: true });
      }
    };

    if (!redirecting) {
      checkPostLoginRedirect();
    }
  }, [user, userLoading, navigate, accounts, redirecting]);

  if (error) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="200px"
        dir="rtl"
      >
        <Typography variant="h6" color="error" gutterBottom>
          שגיאה
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="200px"
      dir="rtl"
    >
      <CircularProgress size={40} />
      <Typography variant="body1" sx={{ mt: 2 }} color="textSecondary">
        {redirecting ? 'מפנה לחשבונית...' : 'טוען...'}
      </Typography>
    </Box>
  );
};

export default InvoiceRedirect;